import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

export const search  = createApiAction('settings/serviceAccess/search',  client.search('/api/setting/service-access'))
export const save    = createApiAction('settings/serviceAccess/save',    client.save('/api/setting/service-access'))
export const destroy = createApiAction('settings/serviceAccess/destroy', client.destroy('/api/setting/service-access/:id'))

const slice = createSlice({
  name: 'serviceAccess',
  initialState: { list: null, count: null },
  reducers: {
    clearList: state => { state.list = null },
  },
  extraReducers(builder) {
    builder
      .addCase(search.fulfilled, (state, action) => {
        state.list  = action.payload.rows
        state.count = action.payload.count
      })
      .addCase(save.fulfilled, (state, action) => {
        const index = state.list?.findIndex(i => i.id === action.payload.id)
        if (index !== undefined && index >= 0) {
          state.list[index] = action.payload
        } else {
          state.list = [...(state.list ?? []), action.payload]
        }
      })
      .addCase(destroy.fulfilled, (state, action) => {
        const serviceId = action.meta.arg.id
        state.list = state.list?.filter(person =>
          !person.personServiceRoles?.some(s => s.id === serviceId)
        )
      })
  },
})

export const { clearList } = slice.actions
export default slice.reducer
